import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "icon icon-completed",
  title: "Completed"
}
const _hoisted_3 = ["textContent"]

import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { Mutations } from '@/store';
import { Game, GameStore } from '@/models/game.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'GameItem',
  props: {
  game: {
    type: Object as PropType<Game>,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const store = useStore();
const router = useRouter();

const storeName = computed<string>(() => {
  return {
    [GameStore.Steam]: 'steam',
    [GameStore.GOG]: 'gog',
    [GameStore.Origin]: 'origin',
    [GameStore.UPlay]: 'uplay',
    [GameStore.Kickstarter]: 'kickstarter',
    [GameStore.EVEOnline]: 'eve',
    [GameStore.Other]: 'other',
    [GameStore.Epic]: 'epic',
  }[props.game.store];
});

const style = computed<string>(() => {
  if (props.game.image) {
    return `background-image: url("/api/images/${props.game.image}")`;
  }
  return '';
});

const showGame = () => {
  store.commit(Mutations.SetViewItem, props.game);
  router.push('/game/' + props.game.url);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: "big-list-item",
    onClick: showGame,
    style: _normalizeStyle(_unref(style))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass('icon icon-' + _unref(storeName)),
      title: `${__props.game.store}`
    }, null, 10, _hoisted_1),
    (__props.game.completed)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("h2", {
      textContent: _toDisplayString(__props.game.name)
    }, null, 8, _hoisted_3)
  ], 4))
}
}

})